export function getEnvVar(key) {
  return process.env[key]
}